import Image from 'next/image';

import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Flexbox } from '../Flexbox';
import { Text } from '../Text';
import { Column } from '../Layout';

export const Wrapper = styled('div')`
  flex-direction: column;
  margin: auto;
  display: flex;
  width: 100%;
  ${mediaQueries.tablet} {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  ${mediaQueries.desktop} {
    flex-wrap: nowrap;
    justify-content: space-between;
  }
`;

export const BadgeColumn = styled(Column)`
  max-width: ${pxToRem(312)};

  ${mediaQueries.tablet} {
    max-width: unset;
  }
`;

export const BadgeWrapper = styled(Flexbox)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  padding: 0;
  ${mediaQueries.tablet} {
    flex-direction: column;
    width: 33%;
    min-width: 120px;
    justify-content: flex-start;
  }
  ${mediaQueries.desktop} {
    max-width: 25%;
    align-items: flex-start;
    padding: 0 ${pxToRem(12)};
  }
`;

export const LogoWrapper = styled('div')`
  width: 40%;
  max-width: 130px;
  ${mediaQueries.tablet} {
    width: 80%;
    max-width: unset;
    margin-bottom: 20px;
  }
`;

export const Logo = styled(Image)`
  width: 100%;
  max-width: 130px;
  ${mediaQueries.tablet} {
    max-width: 110px;
  }
`;

export const TextWrapper = styled('div')`
  align-items: center;
  width: 50%;
  ${mediaQueries.tablet} {
    width: 80%;
  }
  ${mediaQueries.desktop} {
    width: 100%;
  }
`;

export const HeaderText = styled(Text)`
  margin-bottom: 10px;
  ${mediaQueries.tablet} {
    max-width: 160px;
  }
`;
